import { render } from "./LinkPartnerModal.vue?vue&type=template&id=0d344b4d"
import script from "./LinkPartnerModal.vue?vue&type=script&lang=js"
export * from "./LinkPartnerModal.vue?vue&type=script&lang=js"

import exportComponent from "/builds/digitalmasters/team-wombat/alenus-bottle-o-ionic/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__